
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import LazyLoad from "react-lazyload";
const Celebrations = () => {
    const [section, setSection] = useState("LabourDay");
    useEffect(() => {

    })
    return (
        <>
            <div className="breadcrumb">
                <h2>Celebrations</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Events & Activities</li>
                    <li>|</li>
                    <li>Celebrations</li>
                </ul>
            </div>
            <div className="inner_page faculty_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex">
                                <button className={section === "LabourDay" ? 'active' : ''} onClick={() => setSection("LabourDay")}>Labour Day</button>
                                <button className={section === "SisterFarewell" ? 'active' : ''} onClick={() => setSection("SisterFarewell")}>Sister Farewell</button>
                                <button className={section === "TeachersDay" ? 'active' : ''} onClick={() => setSection("TeachersDay")}>Teachers Day</button>
                                <button className={section === "IndependenceDay" ? 'active' : ''} onClick={() => setSection("IndependenceDay")}>Independence Day</button>
                                <button className={section === "FathersFeast" ? 'active' : ''} onClick={() => setSection("FathersFeast")}>Fathers feast DA</button>
                            </div>
                        </div>
                    </div>

                    {section === "LabourDay" && (
                        <div className="row">
                            <div className="col-md-12"><h3 className="heading">Labour Day</h3></div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SFSAP/public/Images/labour_day_1.jpg">
                                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/labour_day_1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></LazyLoad>
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SFSAP/public/Images/labour_day_2.jpg">
                                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/labour_day_2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></LazyLoad>
                                </a>
                            </div>                           
                        </div>
                    )
                    }
                    {section === "SisterFarewell" && (
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="heading">Sister Farewell</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SFSAP/public/Images/Sister_Farewell_1.jpg">
                                   <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Sister_Farewell_1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></LazyLoad>
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SFSAP/public/Images/Sister_Farewell_2.jpg">
                                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Sister_Farewell_2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></LazyLoad>
                                </a>
                            </div> 
                        </div>
                    )
                    }
                    {section === "TeachersDay" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Teachers Day</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SFSAP/public/Images/teachers_day_1.jpg">
                                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/teachers_day_1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></LazyLoad>
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SFSAP/public/Images/teachers_day_2.jpg">
                                    
                                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/teachers_day_2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></LazyLoad>
                                </a>
                            </div>

                        </div>
                    )
                    }

                    {section === "IndependenceDay" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Independence Day</h3>
                            </div> 

                        </div>
                    )
                    }

                    {section === "FathersFeast" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Fathers feast DA</h3>
                            </div> 
                        </div>
                    )

                    }
                    

                </div>
            </div>
        </>
    )
}

export default Celebrations
